export default {
  about: "About",
  applyNow: "Apply now",
  browseSaasTools: "Browse our recommended SaaS tools and their specials for startups.",
  exclusiveToDelta: "Exclusive to Delta",
  saasTools: "SaaS Tools",
  startupSavings: "Startup Savings",
};
